module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('strong', [_vm._v("TO MY FATHER, HANK, MY MOTHER, JOYCE, "), _c('br'), _vm._v("AND MY BROTHER, BRIAN. "), _c('br'), _vm._v("I AM ETERNALLY GRATEFUL YOU ARE MY FAMILY. "), _c('br'), _vm._v("I LOVE YOU.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55949086","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ded.vue
// module id = 63
// module chunks = 0